export const t10s = {
  label: 'Password',
};
